export default __webpack_public_path__ + "static/media/inr_red.9f505bcd.svg";